import './Blankslate-3e043a96.css';

var classes = {"Container":"prc-Blankslate-Container-XATLP","Blankslate":"prc-Blankslate-Blankslate-7GPW-","Description":"prc-Blankslate-Description-OGHRk","Heading":"prc-Blankslate-Heading-H4xby","Action":"prc-Blankslate-Action-SK5XS","Visual":"prc-Blankslate-Visual-PeTD-"};

export { classes as default };
